export const COLORS = {
  RED: '#eb0043',
  GREEN: '#00be70',
  ORANGE: '#ef6902',
  BLUE: '#599afe',
} as const

export const POSITIONS = {
  TOP: 'top',
  LEFT: 'left',
  CENTER: 'center',
  BOTTOM: 'bottom',
} as const

export const TOAST_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  INFO: 'info',
  WARN: 'warn',
} as const

export type ToastType = typeof TOAST_TYPES[keyof typeof TOAST_TYPES]

export type ToastOptions = {
  gravity?: string
  position?: string
  escapeMarkup?: boolean
  offset?: { x: number; y: number }
  style?: { background: string }
  className?: string
  text?: string
  avatar?: string
  debugMessage?: Error | string
  [key: string]: unknown
}

export const DEFAULT_OPTIONS: ToastOptions = {
  gravity: POSITIONS.TOP,
  position: POSITIONS.CENTER,
  escapeMarkup: false,
  offset: {
    x: 0,
    y: -5,
  },
  style: {
    background: COLORS.GREEN,
  },
}

export const TOASTS: Record<ToastType, ToastOptions> = {
  [TOAST_TYPES.SUCCESS]: DEFAULT_OPTIONS,
  [TOAST_TYPES.ERROR]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.RED,
    },
  },
  [TOAST_TYPES.INFO]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.BLUE,
    },
  },
  [TOAST_TYPES.WARN]: {
    ...DEFAULT_OPTIONS,
    style: {
      background: COLORS.ORANGE,
    },
  },
}

export const TOAST_CLASS: string = 'data-testid-toast'
